import { type DropDownSelectOption } from '../../../../../components';
import { programmeOptions } from '../../../../Application/components/ApplicationForm/ProgrammeChoice/options';
import { APPLICATION_STATUS_TYPE } from '../../../../../utils/statusConstants/statusConstants';

export const programme: DropDownSelectOption[] = (
  programmeOptions as any[]
).map(department => ({
  value: department.value,
  label: department.label,
}));

export const localIndicator: DropDownSelectOption[] = [
  { value: 'true', label: 'Y' },
  { value: 'false', label: 'N' },
];

export const hkpfsIndicator: DropDownSelectOption[] = [
  { value: `{"nin":["",null]}`, label: 'Yes' },
  { value: `{"in":["",null]}`, label: 'No' },
];

export const meetConditionStatus: DropDownSelectOption[] = [];
export const qualificationCheckStatus: DropDownSelectOption[] = [];

export const currentStatus = (viewHasPaid: boolean): DropDownSelectOption[] => {
  return [
    ...(viewHasPaid
      ? []
      : [
          { value: APPLICATION_STATUS_TYPE.CREATED, label: 'Created' },
          {
            value: APPLICATION_STATUS_TYPE.APPLICATION_FEE_PENDING,
            label: 'Application Fee Pending',
          },
        ]),
    {
      value: APPLICATION_STATUS_TYPE.PARTNER_NOMINATION_PENDING,
      label: 'Pending Partner Nomination',
    },
    { value: APPLICATION_STATUS_TYPE.SUBMITTED, label: 'Submitted' },

    {
      value: APPLICATION_STATUS_TYPE.UNDER_SUPERVISOR,
      label: 'Under Supervisor',
    },
    {
      value: APPLICATION_STATUS_TYPE.IN_NOMINATION_POOL,
      label: 'In Nomination Pool',
    },
    { value: APPLICATION_STATUS_TYPE.UNDER_DORPGS, label: 'Under DoRpgS' },
    {
      value: APPLICATION_STATUS_TYPE.UNDER_INTERVIEW_PANEL,
      label: 'Under Interview Panel',
    },
    { value: APPLICATION_STATUS_TYPE.UNDER_DSRC, label: 'Under D/SRC' },
    { value: APPLICATION_STATUS_TYPE.UNDER_HOD_DOS, label: 'Under HoD/DoS' },
    { value: APPLICATION_STATUS_TYPE.UNDER_FRCSB, label: 'Under FRC/SB' },
    { value: APPLICATION_STATUS_TYPE.UNDER_GS, label: 'Under GS' },
    {
      value: APPLICATION_STATUS_TYPE.UNDER_PANEL,
      label: 'Under University Panel',
    },
    { value: APPLICATION_STATUS_TYPE.OFFERED, label: 'Offered' },
    { value: APPLICATION_STATUS_TYPE.LAPSED, label: 'Offer Lapsed' },
    {
      value: APPLICATION_STATUS_TYPE.CONDITION_MEET_LAPSED,
      label: 'Meet Condition Lapsed',
    },
    { value: APPLICATION_STATUS_TYPE.REGISTERED, label: 'Registered' },
    {
      value: APPLICATION_STATUS_TYPE.OFFER_PROVISIONING,
      label: 'Offer Provisioning',
    },
    {
      value: APPLICATION_STATUS_TYPE.FAILED_PROVISIONING,
      label: 'Failed Provisioning',
    },
    {
      value: APPLICATION_STATUS_TYPE.UNDER_REGISTRATION,
      label: 'Under Registration',
    },
    {
      value: APPLICATION_STATUS_TYPE.REGISTRATION_FEE_PENDING,
      label: 'Pending for Registration Fee',
    },
    {
      value: APPLICATION_STATUS_TYPE.REGISTRATION_FEE_SETTLED,
      label: 'Registration Fee Settled',
    },
    { value: APPLICATION_STATUS_TYPE.RETURNED, label: 'Returned' },
    { value: APPLICATION_STATUS_TYPE.WITHDRAWN, label: 'Withdrawn' },
    { value: APPLICATION_STATUS_TYPE.DECLINED, label: 'Declined' },
    { value: APPLICATION_STATUS_TYPE.OVERDUE, label: 'Overdue' },
    { value: APPLICATION_STATUS_TYPE.UNSUCCESSFUL, label: 'Not Considered' },
  ];
};
